export default function stream(axios: any) {
  async function uploadThumbnail(image: File, payload: { [key: string]: any } = {}) {
    const { id } = payload;

    const formData = new FormData();
    formData.append('preview', image);
    // eslint-disable-next-line
    for (const [key, value] of Object.entries(payload)) {
      formData.append(key, value as any);
    }

    const response = await axios.post(`/streams/${id}/uploadPreviewImage`, formData, {
      ...axios.defaults.headers.common,
      'Content-Type': 'multipart/form-data',
    });
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/stream] uploadThumbnail Error', e);
    }
    return null;
  }

  return {
    uploadThumbnail,
  };
}
